import { render, staticRenderFns } from "./TrialBalance.vue?vue&type=template&id=22236fc4"
import script from "./TrialBalance.vue?vue&type=script&lang=js"
export * from "./TrialBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports